<template>
  <!-- 수급업체 정보 -->
  <div>
    <!-- =========================== Control =========================== -->
    <div>
      <div class="flex justify-between items-center">
        <p class="title mt-5 mb-5">관리감독 부서 및 종사자 정보</p>
        <div v-if="!readonly && !isPrint">
          <vs-button color="secondary" @click="addRow"> 항목추가 </vs-button>
          <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow"> 선택삭제 </vs-button>
        </div>
      </div>
    </div>
    <table id="infoTable">
      <colgroup>
        <col v-if="!readonly && !isPrint" width="2%" />
        <col width="4%" />
      </colgroup>
      <!-- =========================== THEAD =========================== -->
      <thead>
        <th v-if="!readonly && !isPrint"><vs-checkbox :value="this.infoDatas.length !== 0 && this.infoDatas.length === this.checked.length" @change="onChangeAllCheck" /></th>
        <th>No.</th>
        <th>부서명</th>
        <th>종사자 정보</th>
      </thead>
      <!-- =========================== TBODY =========================== -->
      <tbody v-for="(_info, _info_i) in infoDatas" :key="_info_i">
        <tr>
          <td v-if="!readonly && !isPrint"><vs-checkbox v-model="checked" :vs-value="_info_i" /></td>
          <td class="text-center">{{ _info_i + 1 }}</td>
          <td width="45%">
            <p v-if="isPrint" class="print-input">{{ _info.input_1 }}</p>
<!--            <field-selector v-else class="w-full" v-model="_info.field_id" :field-name="_info.field_name" :readonly="readonly" :popup-title="'업체선택'" @select="(param)=> {-->
<!--              onSelectFieldSelector(_info_i, param)-->
<!--            }" />-->
            <company-selector
              v-else class="w-full"
              v-model="_info.field_id"
              :title="'업체선택'"
              :readonly="readonly"
              @select="(param)=> {
              onSelectFieldSelector(_info_i, param)
            }" />
          </td>
          <!-- 시스템 사용자 정보 버튼 -->
          <td>
            <div class="h-12 flex justify-center items-center cursor-pointer select-none ease-out duration-200" :style="{ transform: _info.arcc ? 'rotate(180deg)' : 'rotate(0deg)' }" @click="() => (_info.arcc = !_info.arcc)">
              <svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.167 7.1665L7.50033 0.499838L0.83366 7.16651L14.167 7.1665Z" fill="black" />
              </svg>
            </div>
          </td>
        </tr>
        <tr v-if="_info.arcc">
          <FieldWorkplaceTableExpand :readonly="readonly" :isPrint="isPrint" :parentsI="_info_i" v-model="_info.expand"
                                     sub-title="종사자 정보"
                                     input1-title="사번" input2-title="소속명" input3-title="부서명" input4-title="성명"/>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import FieldWorkplaceTableExpand from "./FieldWorkplaceTableExpand.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
export default {
  components: {CompanySelector, FieldSelector, FieldWorkplaceTableExpand },
  props: {
    readonly: Boolean,
    isPrint: Boolean,
    value: Array,
  },
  watch: {
    value: {
      handler(value) {
        this.infoDatas = value;
      },
    },
    infoDatas: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      infoDatas: this.value,
      checked: [],
    };
  },
  methods: {
    addRow() {
      this.infoDatas.push({ arcc: false, expand: [], field_id: 0, field_name: '' });
    },
    deleteRow() {
      this.infoDatas = this.infoDatas.filter((ifd, ifd_i) => {
        return !this.checked.includes(ifd_i);
      });
      this.checked = [];
    },
    onChangeAllCheck() {
      if (this.checked.length !== this.infoDatas.length) {
        this.checked = this.infoDatas.map((e, i) => i);
      } else this.checked = [];
    },
    onSelectFieldSelector(index, value) {
      this.infoDatas[index].field_name = value.field_name
    }
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
  }
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 18px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    trans_info: translateY(-50%);
    left: 0px;
    border-radius: 100%;
  }

  & > span {
    color: #696d71;
  }
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

table {
  width: 100%;
  border-collapse: collapse;
  background: #f9f9f9;

  &,
  th,
  td {
    border-top: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
  }

  th {
    text-align: center;
    padding: 16px 6px;
  }

  td {
    padding: 6px;
  }
}

.expand {
  background: #fff;
  padding: 0px;
  padding-bottom: 30px;
  table tbody {
    background: #fff;
  }
}
</style>
